import { createAtlasClient } from "@atlas-int/data";

const {
  REACT_APP_API_STAGING_REWRITE_BASE_URL,
  REACT_APP_API_REWRITE_BASE_URL,
} = import.meta.env;

const stagingGraphQlBase = REACT_APP_API_STAGING_REWRITE_BASE_URL ?? "";
const productionGraphQlBase = REACT_APP_API_REWRITE_BASE_URL ?? "";
const graphQlHost = import.meta.env.DEV
  ? stagingGraphQlBase
  : productionGraphQlBase;

if (!graphQlHost) {
  console.warn("GraphQL base URL is not configured.");
}

/**
 * Apollo Client singleton.
 * Exported for use in both React components (via ApolloProvider) and
 * React Router loaders (for prefetching into cache).
 */
export const apolloClient = createAtlasClient({
  graphqlUrl: `${graphQlHost.replace(/\/$/, "")}/graphql`,
});

export default apolloClient;
